var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_242_2036)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50 100C77.6142 100 100 77.6142 100 50C100 22.3858 77.6142 0 50 0C22.3858 0 0 22.3858 0 50C0 77.6142 22.3858 100 50 100Z",
    fill: "#32BA7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2246 72.5553L62.9344 98.265C84.2278 92.5868 100.001 73.1862 100.001 50.0001C100.001 49.5269 100.001 49.0537 100.001 48.5805L79.8114 29.9685L37.2246 72.5553Z",
    fill: "#0AA06E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2626 61.1988C53.4708 63.407 53.4708 67.1925 51.2626 69.4007L46.6884 73.9748C44.4802 76.183 40.6947 76.183 38.4865 73.9748L18.455 53.7856C16.2468 51.5774 16.2468 47.7919 18.455 45.5837L23.0291 41.0095C25.2373 38.8013 29.0228 38.8013 31.231 41.0095L51.2626 61.1988Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7705 26.3407C70.9787 24.1325 74.7642 24.1325 76.9724 26.3407L81.5466 30.9149C83.7548 33.1231 83.7548 36.9085 81.5466 39.1167L46.8462 73.6593C44.638 75.8675 40.8525 75.8675 38.6443 73.6593L34.0702 69.0852C31.862 66.877 31.862 63.0915 34.0702 60.8833L68.7705 26.3407Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_242_2036"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.abc8978da961820474b8111cf7a08fdf.svg";
export { ForwardRef as ReactComponent };